import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export default function ThumbtackIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <g fill="none">
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          d="M5.39562 8.1577L15.7201 18.4822M10.2403 13.7598L3.00002 21M13.6639 16.3826L20.1636 9.88295C21.1163 8.93029 21.1163 7.38572 20.1636 6.43306L17.445 3.7145C16.4924 2.76183 14.9478 2.76184 13.9951 3.7145L7.49547 10.2142L13.6639 16.3826Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
}
